import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, Button, PageHeader } from 'antd'
import AdminRoleList from '../../components/AdminRoleList'
import { AdminRoleForm } from '../../components/Forms'
import { AdminRoleProvider, AdminRoleConsumer } from '../../context/AdminRoleContext'

export default class AdminRole extends Component {

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="role/add">
        <Button type="primary" shape="round">
        Create new role
        </Button>
      </Link>
    )
  }

  render() {
    const { permissions, history, match: { params: { roleName } } }: any = this.props

    return (
      <AdminRoleProvider>
        <AdminRoleConsumer>
          {({ fetching, error, permissions: rolePermissions, roles, role, requestAdminRoleList, requestAdminRoleFind, requestAdminRoleCreate, requestAdminRoleUpdate, requestAdminRoleDelete }) => {

            // Create or edit an entity
            if (roleName) {
              // We are editing, so we need to find the entity to edit
              let addon: any = {
                permissions: permissions
              }
              if (roleName !== 'add') {
                addon = {
                  ...addon,
                  roleName: roleName
                }
              }

              return (
                <Card>
                  <PageHeader title={roleName === 'add' ? 'New Role' : 'Edit Role'} onBack={() => history.replace('/admin/role')}>
                    <AdminRoleForm
                      {...addon}

                      data={role}
                      roles={rolePermissions}
                      loading={fetching}
                      error={error}

                      history={history}

                      loadAdminRole={requestAdminRoleFind}
                      loadAdminRoles={requestAdminRoleList}

                      dispatchCreate={requestAdminRoleCreate}
                      dispatchUpdate={requestAdminRoleUpdate}
                    />
                  </PageHeader>
                </Card>
              )
            }

            return (
              <Card title="List of user roles" extra={this.renderAdd()}>
                <AdminRoleList
                  permissions={permissions}
                  loading={fetching}
                  roles={roles}
                  history={history}
                  loadAdminRoles={requestAdminRoleList}
                  deleteAdminRole={requestAdminRoleDelete}
                />
              </Card>
            )
          }}
        </AdminRoleConsumer>
      </AdminRoleProvider>
    )
  }
}
